import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Utils";
import { AudioManager } from "../../AudioManager";
import { BoardManager } from "./BoardManager";
import { GameManager } from "../../GameManager";
import { ButtonWithText } from "../../utils/ButtonWithText";
declare var gamezop: any;
declare var oMetaManager: any;
export class PauseLayer extends Phaser.GameObjects.Container {

    private audioOnButton: Button;
    private audioOffButton: Button;
    private resetButton: Button;
    private container1: Phaser.GameObjects.Container;
    private container2: Phaser.GameObjects.Container;
    private cancelButton: Button;
    private restartButton: Button;

    constructor(scene: Phaser.Scene) {

        super(scene);

        const darkLayer = new Phaser.GameObjects.Graphics(this.scene);
        darkLayer.fillStyle(0x2e50b3, .65);
        darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(darkLayer);

        const scaledItemsContainer = new Phaser.GameObjects.Container(this.scene);
        scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        scaledItemsContainer.scaleY = GameVars.scaleY;
        this.add(scaledItemsContainer);

        let menuBackgroundSegment: Phaser.GameObjects.Image;
        for (let i = 0; i < 12; i++) {
            menuBackgroundSegment = new Phaser.GameObjects.Image(this.scene, 0, -60 + 30 * i, "texture_atlas_1", "leaderboard_middle");
            scaledItemsContainer.add(menuBackgroundSegment);
        }

        menuBackgroundSegment = new Phaser.GameObjects.Image(this.scene, 0, -60 + 30 * 12, "texture_atlas_1", "leaderboard_bottom");
        scaledItemsContainer.add(menuBackgroundSegment);

        const topBar = new Phaser.GameObjects.Image(this.scene, 0, -100, "texture_atlas_3", "bar");
        topBar.setScale(1, 1);
        scaledItemsContainer.add(topBar);


        this.container1 = new Phaser.GameObjects.Container(this.scene);
        scaledItemsContainer.add(this.container1);

        const titleLabel = new Phaser.GameObjects.Text(this.scene, 0, -100, GameVars.gameText[GameVars.gameData.language].PAUSE, { fontFamily: "Baloo", fontSize: "60px", align: "center", color: "#FFFFFF" });
        titleLabel.setOrigin(.5);
        this.container1.add(titleLabel);

        const closeButton = new Button(this.scene, 220, -98, "texture_atlas_3", "btn_close_off", "btn_close_on");
        closeButton.onDown(this.onClickClose, this);
        closeButton.setScale(0);
        scaledItemsContainer.add(closeButton);

        this.scene.tweens.add({
            targets: closeButton,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Elastic.Out,
            duration: 650,
            delay: 400
        });

        this.resetButton = new Button(this.scene, 0, 190, "texture_atlas_4", "btn_replay_off", "btn_replay_on");
        this.resetButton.onDown(this.onClickReset, this);
        this.container1.add(this.resetButton);

        // if(!gamezop.isBattleGame()) this.resetButton.setVisible(false)

        this.audioOnButton = new Button(this.scene, 0, 30, "texture_atlas_4", "btn_sound_on_off", "btn_sound_on_on");
        this.audioOnButton.onDown(this.onClickAudioButton, this);
        this.container1.add(this.audioOnButton);

        this.audioOffButton = new Button(this.scene, 0, 30, "texture_atlas_3", "btn_sound_off_off", "btn_sound_off_on");
        this.audioOffButton.onDown(this.onClickAudioButton, this);
        this.container1.add(this.audioOffButton);

        if (GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }

        this.container2 = new Phaser.GameObjects.Container(this.scene);
        this.container2.visible = false;
        scaledItemsContainer.add(this.container2);

        const titleLabel2 = new Phaser.GameObjects.Text(this.scene, 0, -100, GameVars.gameText[GameVars.gameData.language].RESTART, { fontFamily: "Baloo", fontSize: "60px", align: "center", color: "#FFFFFF" });
        titleLabel2.setOrigin(.5);
        this.container2.add(titleLabel2);

        const resetLabel = new Phaser.GameObjects.Text(this.scene, 0, 35, GameVars.gameText[GameVars.gameData.language].LOOSE, { fontFamily: "Baloo", fontSize: "40px", align: "center", color: "#FFFFFF", wordWrap: { width: 300, useAdvancedWrap: true } });
        resetLabel.setOrigin(.5);
        this.container2.add(resetLabel);

        this.cancelButton = new Button(this.scene, 0, 0, "texture_atlas_4", "btn_pay");
        this.cancelButton.onDown(this.onClickCancel, this);
        this.cancelButton.x = 0;
        this.cancelButton.y = 170;
        this.container2.add(this.cancelButton);

        // const cancelButtonImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_4", "btn_pay");
        const cancelButtonLabel = new Phaser.GameObjects.Text(this.scene, 0, 170, GameVars.gameText[GameVars.gameData.language].CANCEL, { fontFamily: "Baloo", fontSize: "25px", color: "#FFFFFF", align: "center", wordWrap: { width: 180, useAdvancedWrap: true } });
        cancelButtonLabel.setOrigin(.5);
        cancelButtonLabel.lineSpacing = -10;
        cancelButtonLabel.setStroke("#0eae3b", 6);
        this.container2.add(cancelButtonLabel);

        // const resetButtonImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_3", "btn_red");
        // const resetButtonLabel = new Phaser.GameObjects.Text(this.scene, 0, 0, GameVars.gameText[GameVars.gameData.language].RESTART, { fontFamily: "Baloo", fontSize: "25px", color: "#FFFFFF", align: "center", wordWrap: { width: 180, useAdvancedWrap: true } });
        // resetButtonLabel.setOrigin(.5);
        // resetButtonLabel.lineSpacing = -10;
        // resetButtonLabel.setStroke("#a21651", 6);

        this.restartButton = new Button(this.scene, 0, 0, "texture_atlas_3", "btn_red");
        this.restartButton.onDown(this.onClickRestart, this);
        this.restartButton.y = 245;
        this.container2.add(this.restartButton);

        const resetButtonLabel = new Phaser.GameObjects.Text(this.scene, 0, 245, GameVars.gameText[GameVars.gameData.language].RESTART, { fontFamily: "Baloo", fontSize: "25px", color: "#FFFFFF", align: "center", wordWrap: { width: 180, useAdvancedWrap: true } });
        resetButtonLabel.setOrigin(.5);
        resetButtonLabel.lineSpacing = -10;
        resetButtonLabel.setStroke("#a21651", 6);
        this.container2.add(resetButtonLabel);

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350
        });
    }

    private onClickClose(): void {

        BoardManager.currentInstance.resume();

        AudioManager.playSound("btn_click");
    }

    private onClickReset(): void {

        this.container1.visible = false;
        this.container2.visible = true;

        AudioManager.playSound("btn_click");
    }

    private onClickCancel(): void {

        this.container1.visible = true;
        this.container2.visible = false;

        AudioManager.playSound("btn_click");
    }

    private onClickRestart(): void {

        gamezop.setState({
            score: GameVars.candyEngine.score,
            fps: Math.floor(GameVars.currentScene.game.loop.actualFps),
            state: "over",
            tcount: GameVars.tc,
            kcount: GameVars.kc,
            metadata: oMetaManager.meta
        })

        GameManager.resetGame();

        AudioManager.playSound("btn_click");
    }

    private onClickAudioButton(): void {

        AudioManager.toggleAudioState();

        if (GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }

        AudioManager.playSound("btn_click");
    }
}
